import { render } from "./LoginBlog.vue?vue&type=template&id=50899ec2&scoped=true"
import script from "./LoginBlog.vue?vue&type=script&lang=js"
export * from "./LoginBlog.vue?vue&type=script&lang=js"

import "./LoginBlog.vue?vue&type=style&index=0&id=50899ec2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50899ec2"]])

export default __exports__